// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OpponentVideoView__container-e8e88f {
  flex: 1;
  height: 100%;
  display: flex;
}

.OpponentVideoView__container-e8e88f video {
  position: relative;
  object-fit: contain !important;
  overflow: hidden;
  max-height: 100%;
  max-width: 100%;
  width: 100%;
}

.OpponentVideoView__inverted-e58b1c {
  transform: scale(-1, 1);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/Shared/OpponentVideo/OpponentVideoView/OpponentVideoView.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,YAAA;EACA,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,8BAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AACF;;AAEA;EACE,uBAAA;AACF","sourcesContent":[".container {\n  flex: 1;\n  height: 100%;\n  display: flex;\n}\n\n.container video {\n  position: relative;\n  object-fit: contain !important;\n  overflow: hidden;\n  max-height: 100%;\n  max-width: 100%;\n  width: 100%;\n}\n\n.inverted {\n  transform: scale(-1, 1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `OpponentVideoView__container-e8e88f`,
	"inverted": `OpponentVideoView__inverted-e58b1c`
};
module.exports = ___CSS_LOADER_EXPORT___;
